/* eslint-disable import/no-unresolved */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useMutation } from 'react-query';
import { isIOS } from 'react-device-detect';
import { OnboardingBodyLayout } from 'assets/components';
import { FLOWS, sendStats } from '../../../services/mixpanel';
import { REQUEST_RESET_PASSWORD } from '../mutations';
import { MXP_RESET_PASSWORD_REQUEST } from '../mixpanel-events';
import Input from '../../../components/Input';
import { clearFormError, handleFormBlur } from '../../../utilities/formsUtils';
import { validateEmail } from '../../../utilities/formValidation';

const ChangePasswordRequest = () => {
  const { t: translate } = useTranslation();

  const history = useHistory();
  const { path } = useRouteMatch();

  const [form, setForm] = useState({
    email: '',
  });

  const { mutate: requestResetPassword, isLoading: isResetPasswordRequested } = useMutation(
    REQUEST_RESET_PASSWORD,
    {
      onSettled: (data) => {
        history.push(`${path}/sent`, {
          ...form,
          ...data,
        });
      },
    }
  );

  const handleSubmitForm = (e) => {
    e.preventDefault();
    sendStats(MXP_RESET_PASSWORD_REQUEST, {}, FLOWS.PASSWORD_RESET);
    requestResetPassword(form?.email?.toLowerCase());
    return true;
  };

  const handleChange = (e) => {
    if (!e || !e.target) return;
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const renderButtons = () => (
    <>
      <div className="d-none d-md-block w-100">
        <button
          className="btn btn-primary w-100 text-bold"
          type="submit"
          form="form-password-reset"
          loading={isResetPasswordRequested ? 'true' : 'false'}
          disabled={isResetPasswordRequested || form.email === '' || !validateEmail(form.email)}>
          {translate('send_code_button_label')}
        </button>
      </div>
      <div className="d-block d-md-none position-fixed bottom-0 bg-lighter w-100 py-3 px-3">
        <button
          className="btn btn-primary w-100 text-bold"
          type="submit"
          form="form-password-reset"
          loading={isResetPasswordRequested ? 'true' : 'false'}
          disabled={isResetPasswordRequested || form.email === '' || !validateEmail(form.email)}>
          {translate('send_code_button_label')}
        </button>
      </div>
    </>
  );

  return (
    <OnboardingBodyLayout
      title={translate('change_password_title')}
      renderButtons={renderButtons}
      withBack
      onPrevClick={history.goBack}>
      <form onSubmit={handleSubmitForm} id="form-password-reset">
        <p className="mt-4 pe-0 pe-md-5">{translate('password_reset_description')}</p>
        <Input
          value={form.email}
          className={`${isIOS ? 'ios' : ''}`}
          groupClassName={`mb-0 mt-4 ${isIOS ? 'ios' : ''}`}
          name="email"
          onChange={handleChange}
          onBlur={handleFormBlur}
          onFocus={clearFormError}
          placeholder={translate('email_input_label')}
          label={translate('email_input_label')}
          errorLabel={translate('email_input_error_label')}
          withFloatingLabel
          withErrorLabel
          required
        />
      </form>
    </OnboardingBodyLayout>
  );
};

export default ChangePasswordRequest;
